import { useEffect } from "react";
import "./invite.scss";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";

// components
import LandingNavbar from "../../components/Navbar/LandingNavbar/LandingNavbar";

const API_URL = "/api/v1";

const Invite = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const inviteToken = searchParams.get("ivtoken") || "";

  const handleInviteAccept = async () => {
    try {
      const session = await axios.get(`${API_URL}/auth/session`);
      if (
        session.status === 200 &&
        session.data.success &&
        session.data.user !== null
      ) {
        const res = await axios.get(
          `${API_URL}/invite/verify?token=${inviteToken}`
        );
        if (res.status === 200 && res.data.success === true) {
          navigate("/dashboard/evaluation");
        }
      }
    } catch (error: any) {
      if (error.response.status === 401) {
        if (error.response.data.user === null) {
          if (inviteToken !== "") {
            Cookies.set("ivtoken", inviteToken);
          }
          navigate("/auth/signup");
        }
      }
    }
  };

  useEffect(() => {
    handleInviteAccept();
    // eslint-disable-next-line
  }, [location, inviteToken]);

  return (
    <div className="invite">
      <LandingNavbar />
    </div>
  );
};

export default Invite;
